module.exports = __webpack_public_path__ + "img/frame-day.6ddd7ec7.png";